import {createAction, handleActions} from 'redux-actions';

const initialState = {
  isOrderPlaced: false,
  orderId: '',
  totalCost: 0.0
};

export const placeOrder = createAction('PLACE_ORDER', checkout => checkout);
export const placeOrderReset = createAction('PLACE_ORDER_RESET', checkout => checkout);

export const addPotsTid = createAction('POTSID_ADD', id => id);
export const paymentComplete = createAction('POTS_PAYMENT_COMPLETE', id => id);

export default handleActions({
  PLACE_ORDER: (state, action) => {
    return {
      ...state, 
      isOrderPlaced: true,
      orderId: action.payload.orderId,
      totalCost: action.payload.totalCost
    };
  },
  POTSID_ADD: (state, action) => {
    return {
      ...state, 
      potsTid: action.payload.potsTid,
    };
  },
  POTS_PAYMENT_COMPLETE: (state, action) => {
    return {
      ...state, 
      potsTid: null
    };
  },
  PLACE_ORDER_RESET: () => initialState
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/checkoutReducer.js